import axios from 'axios'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import store from '@/store'
import { router } from '@/router/index'
import errorCode from '@/const/error-code'
import { ElMessage } from 'element-plus'
import Qs from 'qs'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: 600000, // 请求超时时间
  paramsSerializer: function (params) { // 序列化请求参数，避免get请求参数出现&,空格等识别错误的问题
    return Qs.stringify(params, { arrayFormat: 'brackets' })
  }
})

// http requeset 拦截
service.interceptors.request.use(config => {
  NProgress.start() // start progress bar
  const token = store.getters.access_token
  if (token) {
    config.headers.Authorization = 'Bearer ' + token// token
  }
  return config
}, error => {
  return Promise.reject(error)
})

// http response 拦截
service.interceptors.response.use(res => {
  NProgress.done()
  const status = Number(res.status) || 200
  const message = res.data.msg || errorCode[status] || errorCode.default
  if (res.data.code === 401) {
    store.commit('SET_ACCESS_TOKEN', '')
    store.commit('SET_ROUTES', [])
    router.push({ path: '/login' })
    return
  }
  // 错误码统一提示
  if (typeof res.data !== 'string' && res.config.responseType !== 'blob' && (status !== 200 || res.data.code !== 200)) {
    ElMessage({
      message: message,
      type: 'error'
    })
    return Promise.reject(new Error(message))
  }

  return res.data
}, error => {
  NProgress.done()
  return Promise.reject(new Error(error))
})

export default service
